import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const KOTModal = ({ isOpen, toggle, handlePrint }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} >
      <ModalHeader toggle={toggle} className="border-0 pb-1">
        <div className="w-100 text-center">
         
          <h5 className="fw-semibold mb-0">Print Kitchen Order Ticket</h5>
        </div>
      </ModalHeader>
      <ModalBody className="text-center">
        <div id="kot-print-content">
          <p className="text-muted mb-3">
            Are you sure you want to print the KOT for this order?
          </p>
          <div className="kot-preview-box border rounded p-3 bg-light">
            <h6 className="fw-bold mb-0">KOT Preview</h6>
            {/* Add KOT content here */}
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center border-0 pt-2">
        <button  onClick={handlePrint} className="btn btn-soft-success">
          <i className="ri-printer-line me-2"></i> Print KOT
        </button>
        <button onClick={toggle} className="btn btn-soft-danger ">
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default KOTModal;
